<template>
  <button
    type="button"
    :class="[buttonSizeClassName, buttonStyleClassName]"
    @click.stop="onClickBtn()"><slot/>{{ text }}</button>
</template>

<script>
export default {
  name:'Button',
  props:{
    btnSize: String,
    btnStyle: String,
    text: String,
    routeName: String,
    routeParams: Object,
    routeQuery: Object,
  },
  computed:{
    buttonSizeClassName(){
      return 'btn_'+this.btnSize;
    },
    buttonStyleClassName(){
      return 'btn_'+this.btnStyle;
    }
  },
  methods:{
    onClickBtn(e){
      if( this.routeName ){
        let routeInfo = { name: this.routeName };
        if(this.routeParams){
          routeInfo.params = this.routeParams;
        }
        if(this.routeQuery){
          routeInfo.query = this.routeQuery;
        }
        this.$router.push(routeInfo);
        return;
      }
      this.$emit('onClickBtn',e);
    }
  }
}
</script>
<style lang="scss" scoped>
/* xsmall */
.btn_xsmall{display:inline-block;height:26px;padding:0 8px;border-radius:$CONTENT_RADIUS;font-weight:500;font-size:14px;line-height:18px;vertical-align:top;letter-spacing:-.05em}
/* small */
.btn_small{display:inline-block;height:38px;padding:6px 12px;border-radius:$CONTENT_RADIUS;font-weight:600;font-size:14px;line-height:24px;vertical-align:top;letter-spacing:-.05em}
/* medium */
.btn_medium{display:inline-block;height:46px;padding:0 14px;border-radius:$CONTENT_RADIUS;font-weight:600;font-size:16px;line-height:26px;vertical-align:top;letter-spacing:-.05em}
/* large */
.btn_large{display:inline-block;height:54px;padding:0 30px;border-radius:$CONTENT_RADIUS;font-weight:700;font-size:20px;line-height:26px;vertical-align:top;letter-spacing:-.05em}

/* secondary */
.btn_secondary{background-color:$SECONDARY_COLOR;color:#fff}
.btn_secondary:hover{background-color:rgba($SECONDARY_COLOR,.8)}
/* secondary_border */
.btn_secondary_border{border:1px solid $DEFAULT_BORDER;background-color:#fff;color:$SECONDARY_COLOR}
.btn_secondary_border:hover{background-color:rgba($SECONDARY_COLOR,.1)}
/* tertiary */
.btn_tertiary{background-color:$TERTIARY_COLOR;color:#fff}
.btn_tertiary:hover{background-color:rgba($TERTIARY_COLOR,.8)}
/* tertiary_border */
.btn_tertiary_border{border:1px solid $DEFAULT_BORDER;background-color:#fff;color:$TERTIARY_COLOR}
.btn_tertiary_border:hover{background-color:rgba($TERTIARY_COLOR,.1)}
/* fourthly */
.btn_fourthly{background-color:$FOURTHLY_COLOR;color:#fff}
.btn_fourthly:hover{background-color:rgba($FOURTHLY_COLOR,.8)}
/* fourthly_border */
.btn_fourthly_border{border:1px solid $DEFAULT_BORDER;background-color:#fff;color:$FOURTHLY_COLOR}
.btn_fourthly_border:hover{background-color:rgba($FOURTHLY_COLOR,.1)}
/* primary */
.btn_primary{background-color:$PRIMARY_COLOR;color:#fff}
.btn_primary:hover{background-color:rgba($PRIMARY_COLOR,.8)}
/* primary_border */
.btn_primary_border{border:1px solid $DEFAULT_BORDER;background-color:#fff;color:$PRIMARY_COLOR}
.btn_primary_border:hover{background-color:rgba($PRIMARY_COLOR,.1)}
/* disabled */
button:disabled,
button:disabled:hover{background-color:$DISABLED_BG;color:$DISABLED_TEXT;box-shadow:none;cursor:no-drop}
/* icon */
button .icon_firfin{margin:0 6px 2px 0;vertical-align:middle;}

button + button{margin-left:8px}
.desc_error + button{margin-top:20px}

.group_btn button + button{margin-top:0;margin-left:8px}

.group_btn_type2 button{min-width:100px}
.group_btn_type2 button + button{margin-top:0;margin-left:8px}

.group_btn_type3 button{min-width:100px}
.group_btn_type3 button + button{margin-top:0;margin-left:8px}

/* 모바일 */
// @media all and (max-width:600px){
//   .group_btn .btn_medium{padding:0 10px}
//   .group_btn_type2 button:nth-child(1){width:calc(30% - 4px);min-width:inherit}
//   .group_btn_type2 button:nth-child(2){width:calc(70% - 4px);min-width:inherit}

//   .group_btn_type3 button:nth-child(1){width:calc(25% - 5.4px);min-width:inherit}
//   .group_btn_type3 button:nth-child(2){width:calc(25% - 5.4px);min-width:inherit}
//   .group_btn_type3 button:nth-child(3){width:calc(50% - 5.4px);min-width:inherit}
// }
@media (prefers-color-scheme: dark) {
  .btn_secondary,
  .btn_secondary_border,
  .btn_tertiary_border,
  .btn_fourthly_border,
  .btn_primary_border{background:rgba(255,255,255,.02)}
  .btn_secondary_border,
  .btn_tertiary_border,
  .btn_fourthly_border,
  .btn_primary_border{border-color:$DEFAULT_BORDER_DARK}
  .btn_secondary_border:hover,
  .btn_tertiary_border:hover,
  .btn_fourthly_border:hover,
  .btn_primary_border:hover{background-color:rgba(255,255,255,.2)}
  .btn_secondary_border{color:#eee}
  .btn_secondary{background-color:$SECONDARY_DARK_COLOR;color:$SECONDARY_COLOR}
  .btn_secondary:hover{background-color:rgba($SECONDARY_DARK_COLOR,.8)}
  /* disabled */
  button:disabled,
  button:disabled:hover{background-color:$DISABLED_BG_DARK;color:$DISABLED_TEXT_DARK;box-shadow:none}
  .btn_secondary_border:disabled,
  .btn_tertiary_border:disabled,
  .btn_fourthly_border:disabled,
  .btn_primary_border:disabled{border-color:$DISABLED_BORDER_DARK}
}
</style>